// Configuración para desarrollo y producción
const config = {
  // En desarrollo usa el proxy, en producción usa la variable de entorno
  API_BASE_URL: process.env.REACT_APP_API_URL || '',

  // Determinar si estamos en desarrollo
  isDevelopment: process.env.NODE_ENV === 'development'
};

// Legacy fallback para FeatureFlagContext cuando la API no responde
export const VENUES_ENABLED_FALLBACK = process.env.REACT_APP_VENUES_ENABLED === 'true';

// Función helper para construir URLs de API
export const getApiUrl = (endpoint: string): string => {
  if (config.isDevelopment) {
    return `${endpoint.startsWith('/api') ? endpoint : `/api${endpoint}`}`;
  }
  return `${config.API_BASE_URL}${endpoint.startsWith('/api') ? endpoint : `/api${endpoint}`}`;
};

export default config; 